import Vue from 'vue';
import Vuex from 'vuex';
import AuthenticationModule, {
  AUTHENTICATION_MODULE_NAME
} from '@/store/modules/authentication.module';
import VeterinarianModule, {
  VETERINARIAN_MODULE_NAME
} from './modules/veterinarian.module';
import VeterinarianUserModule, {
  VETERINARIAN_USER_MODULE_NAME
} from './modules/veterinarian-office-user.module';
import CustomersModule, {
  CUSTOMERS_MODULE_NAME
} from './modules/customer.module';
import AdminUserModule, {
  ADMIN_USER_MODULE_NAME
} from './modules/admin-user.module';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from './modules/registered-tag.module';
import ReportModule, { REPORT_MODULE_NAME } from './modules/report.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    [AUTHENTICATION_MODULE_NAME]: AuthenticationModule,
    [VETERINARIAN_MODULE_NAME]: VeterinarianModule,
    [VETERINARIAN_USER_MODULE_NAME]: VeterinarianUserModule,
    [CUSTOMERS_MODULE_NAME]: CustomersModule,
    [ADMIN_USER_MODULE_NAME]: AdminUserModule,
    [REGISTERED_TAG_MODULE_NAME]: RegisteredTagModule,
    [REPORT_MODULE_NAME]: ReportModule
  },
  strict: debug
});
